export default "__VITE_ASSET__58d950fb__"